import Vue from 'vue';

import { isEmpty } from 'lodash/lang';
import Router from 'vue-router';
import * as authHelper from '../helper/auth';

Vue.use(Router);

const router = new Router({
    base: '/',
    routes: [
        {
            path: '/',
            redirect: '/welcome',
        },
        {
            path: '/welcome',
            name: 'welcome',
            component: () => import(/* webpackChunkName: "welcome" */ '@/components/Welcome/Welcome'),
            meta: {
                requiresAuth: true,
                title: '导航'
            },
        },
        {
            path: '/login/:username?',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '@/components/Login/Login'),
            meta: {
                title: '登录',
            }
        },
        {
            path: '/third/wxlogin',
            name: 'thirdWxLogin',
            component: () => import(/* webpackChunkName: "thirdWxLogin" */ '@/components/Login/ThirdPartyLoginCallback/WxLogin'),
            meta: {
                title: '微信登录',
            }
        },
        {
            path: '/third/oalogin',
            name: 'thirdOALogin',
            component: () => import(/* webpackChunkName: "thirdOALogin" */ '@/components/Login/ThirdPartyLoginCallback/OALogin'),
            meta: {
                title: 'OA 登录',
            }
        },
        {
            path: '/forgotPassword/:username?',
            name: 'forgotPassword',
            component: () => import(/* webpackChunkName: "forgotPassword" */ '@/components/Login/ForgotPassword'),
            meta: {
                title: '忘记密码',
            }
        },
        {
            path: '/container/:app?/:path*',
            name: 'container',
            component: () => import(/* webpackChunkName: "container" */ '@/components/Container/Container'),
            meta: {
                title: '应用容器',
                requiresAuth: true
            },
        },
        {
            path: '/error404',
            name: 'error404',
            component: () => import(/* webpackChunkName: "error404" */ '@/components/ErrorPage/Error404'),
            meta: {
                title: '页面未找到',
            }
        },
        {
            path: '/download',
            name: 'Download',
            component: () => import(/* webpackChunkName: "download" */ '@/components/Download/index'),
            meta: {
                title: '下载集合',
                requiresAuth: false
            },

        },
        {
            path: '/download/app',
            name: 'SingleApp',
            component: () => import(/* webpackChunkName: "SingleApp" */ '@/components/Download/singleApp'),
            meta: {
                title: 'app下载',
                requiresAuth: false
            },

        },
        {
            path: '*',
            redirect: 'error404',
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!authHelper.isLoggedIn()) {
            let query;
            if (isEmpty(to.query)) {
                query = {
                    redirect: to.path,
                };
            } else {
                // @TODO 这里 query 应该是 redirect 的一部分
                // 但是，这样处理也不影响最终的效果，最后在登录成功的时候会
                // 将参数添加进来
                query = {
                    redirect: to.path,
                    ...to.query,
                };
            }
            next({
                name: 'login',
                query,
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
